(function () {
  const smartCartDrawerBtn = document.querySelector('[js-rebuy-smart-cart-drawer-btn]');

  smartCartDrawerBtn?.addEventListener('click', function (e) {
    Rebuy?.SmartCart?.show()
  });

  document.addEventListener('rebuy:cart.ready', function () {
    const config = {
      containerId: '#onwardWidget',
      selector: '.rebuy-cart__checkout-button'
    };

    if (!window.OnwardSetup) return;

    const setup = new window.OnwardSetup();

    setup.addContainer(config.containerId, {
      position: 'afterend'
    });

    setup.addCheckoutPlus(config.selector, {
      optOutSelector: config.selector,
      optOutPosition: 'afterend'
    });
  });
})();